import { render, staticRenderFns } from "./LoginPolicyEdit.vue?vue&type=template&id=3cea293a&"
import script from "./LoginPolicyEdit.vue?vue&type=script&lang=js&"
export * from "./LoginPolicyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports